// extracted by mini-css-extract-plugin
export default {"container":"AccesForbiden_container__oGjEm","imgcontainer":"AccesForbiden_imgcontainer__jCcpX","errorcode":"AccesForbiden_errorcode__fXCiv"};